module.exports = __webpack_public_path__ + "img/weddingrings.ca5107e.jpg";